module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_8.93f193a0.png";